var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasBreadcrumbs) ? _c('ul', {
    staticClass: "breadcrumbs uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    key: "home",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("\n      Dashboard\n    ")])], 1), _vm._v(" "), _vm._l((_vm.orderedBreadcrumbs), function(breadcrumb) {
    return _c('li', {
      key: breadcrumb.id,
      class: {
        'uk-disabled': _vm.isDisabledItem(breadcrumb)
      }
    }, [(_vm.getRoute(breadcrumb)) ? _c('router-link', {
      attrs: {
        "to": _vm.getRoute(breadcrumb)
      }
    }, [_vm._v("\n      " + _vm._s(_vm.getText(breadcrumb)) + "\n    ")]) : _c('span', [_vm._v("\n      " + _vm._s(_vm.getText(breadcrumb)) + "\n    ")])], 1)
  })], 2) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4caf11b6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Breadcrumbs.vue
// module id = 1979
// module chunks = 0